/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ProductGroup} from './ProductGroup';
import {Manufacturer} from './Manufacturer';

export interface DiscountMatrix {
  manufacturer: Manufacturer;
  productGroup: ProductGroup;
  manufacturerId: number;
  productGroupId: number;
  discount: number;
  enabled?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  deleted?: boolean;
}
